import React from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import PlayBtn from "../../../../assets/images/play-btn.png";
import LeftBarSports from "../../../components/LeftBarSports";

import MiniRoulette from "../../../../assets/images/spribe/MiniRoulette.jpg";
import Goal from "../../../../assets/images/spribe/Goal.jpg";
import Hilo from "../../../../assets/images/spribe/Hilo.jpg";
import Dices from "../../../../assets/images/spribe/Dice.jpg";
import Plinko from "../../../../assets/images/spribe/Plinko.jpg";
import Aviator from "../../../../assets/images/spribe/aviator.jpg";
import Mines from "../../../../assets/images/spribe/Mines.jpg";

import { useSelector } from "react-redux";

const Spribe = () => {
  const { isAuth } = useSelector((state) => state.auth);

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="d-xl-none">
          <LeftBarSports />
        </div>

        <div className="slots-section">
          <div className="games-section">
            <div className="game-heading my-4">
              <h3>Spribe</h3>
            </div>

            <ul>
              <li>
                <a href="/casino/spribe/aviator">
                  <img src={Aviator} alt="Live casino game" />
                  <div className="casino_overlay">
                    <img src={PlayBtn} />
                  </div>
                </a>
              </li>
              <li>
                <a href="/casino/spribe/plinko">
                  <img src={Plinko} alt="Live casino game" />
                  <div className="casino_overlay">
                    <img src={PlayBtn} />
                  </div>
                </a>
              </li>
              <li>
                <a href="/casino/spribe/dices">
                  <img src={Dices} alt="Live casino game" />
                  <div className="casino_overlay">
                    <img src={PlayBtn} />
                  </div>
                </a>
              </li>
              <li>
                <a href="/casino/spribe/hilo">
                  <img src={Hilo} alt="Live casino game" />
                  <div className="casino_overlay">
                    <img src={PlayBtn} />
                  </div>
                </a>
              </li>
              <li>
                <a href="/casino/spribe/goal">
                  <img src={Goal} />
                  <div className="casino_overlay">
                    <img src={PlayBtn} />
                  </div>
                </a>
              </li>
              <li>
                <a href="/casino/spribe/miniroulette">
                  <img src={MiniRoulette} />
                  <div className="casino_overlay">
                    <img src={PlayBtn} />
                  </div>
                </a>
              </li>
              <li>
                <a href="/casino/spribe/mines">
                  <img src={Mines} />
                  <div className="casino_overlay">
                    <img src={PlayBtn} />
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Spribe;
